var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tooltip',{attrs:{"top":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [(_vm.isActive)?_c('v-icon',_vm._g(_vm._b({attrs:{"color":"green","small":""}},'v-icon',attrs,false),on),[_vm._v(" mdi-check-bold ")]):_c('v-icon',_vm._g(_vm._b({attrs:{"color":"grey lighten-1","small":""}},'v-icon',attrs,false),on),[_vm._v(" mdi-close-thick ")])]}}])},[_vm._v(" "+_vm._s(_vm.subtitle)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }